module.exports = __webpack_public_path__ + "img/hx-jfycb-w.94843e82.svg";